export const myhubTabs = [
  {
    label: 'Dates',
    url: 'dates'
  },
  {
    label: 'Categories',
    url: 'categories'
  },
  {
    label: 'Identities',
    url: 'identities'
  },
  {
    label: 'Events',
    url: 'events'
  },
  {
    label: 'Triggers',
    url: 'triggers'
  },
  {
    label: 'Prizes',
    url: 'prizes'
  },
  {
    label: 'Predictions',
    url: 'predictions'
  },
  {
    label: 'Card Packs',
    url: 'card-packs'
  },
]

export const marketplaceTabs = [
  {
    label: 'Cards',
    url: 'cards?status=not_owned,for_sale'
  },
  {
    label: 'Card Packs',
    url: 'card-packs?status=not_owned,for_sale'
  },
]

export const craftingTabs = [
  {
    label: 'Identities',
    url: 'identity'
  },
  {
    label: 'Predictions',
    url: 'prediction'
  },
]

export const ProfileTabs = [
  {
    label: 'Profile',
    url: 'me'
  },
  {
    label: 'Prediction Status',
    url: 'prediction-status'
  },
  {
    label: 'Transactions',
    url: 'transactions'
  },
  {
    label: 'Settings',
    url: 'settings'
  },
]

export const PrivaciesTabs = [
  {
    label: 'Learn To Play',
    url: 'learn-to-play'
  },
  {
    label: 'Game Rules',
    url: 'rules'
  },
  {
    label: 'Privacy Policy',
    url: 'privacy-policy'
  },
  {
    label: 'Terms of Use',
    url: 'terms-of-use'
  },
]
